import { createAsyncThunk } from '@reduxjs/toolkit';
import userActivityApi from '../../../api/userActivityApi';

// ---------------------------------------------------------------------

const REDUCER_NAME = 'userActivity';

export const GetUserActivity = createAsyncThunk<any, any>(
  `${REDUCER_NAME}/getUserActivity`,
  async (params, thunkAPI) => {
    const res = await userActivityApi.get(params);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);
